import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../../shared/services/storage.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-eshop-success',
  templateUrl: './eshop-success.component.html',
  styleUrls: ['./eshop-success.component.scss']
})
export class EshopSuccessComponent implements OnInit {
  invoiceUrl: any;

  constructor(public router: Router,
              private _location: Location) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.invoiceUrl = StorageService.getItem('invoiceUrl');
    if (!this.invoiceUrl) {
      this.back();
    } else {
      StorageService.removeItem('cartItems');
      StorageService.removeItem('selectedStockist');
    }
  }

  navigateTo() {
    window.open(this.invoiceUrl, '_blank');
  }

  back() {
    this._location.back();
  }
}
